import React from "react";
import "./ICTLabs.css";
import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";

const ictLabsData = [
  {
    title: "Computer Programming Lab",
    image: "/campuslife/ictlab/programming-lab.JPG",
  },
  {
    title: "Data Science Lab",
    image: "/campuslife/ictlab/machine-learning.JPG",
  },
  {
    title: "AI & ML Lab",
    image: "/campuslife/ictlab/ai-lab.JPG",
  },
  {
    title: "Networking Lab",
    image: "/campuslife/ictlab/networking-lab.JPG",
  },
  {
    title: "Spoken English Lab",
    image: "/campuslife/ictlab/spoken-english.JPG",
  },
  {
    title: "Software Engineering Lab",
    image: "/campuslife/ictlab/software-lab.JPG",
  },
  {
    title: "Digital Library",
    image: "/campuslife/ictlab/digital-lab.JPG",
  },
];

const ICTLabs = () => {
  return (
    <>
    <Navbar />
    <div className="ictlabs-page">
      {/* Banner */}
      <div className="ictlabs-banner">
        <img src="/campuslife/ictlab.JPG" alt="ICT Labs" />
        <div className="banner-overlay">
          <h1>ICT Laboratories</h1>
          <p>Empowering Digital Learning & Innovation</p>
        </div>
      </div>

      {/* About Section */}
      <section className="ictlabs-about">
        <h2>About ICT Labs</h2>
        <p>
          The University ICT Laboratories are equipped with modern computing
          infrastructure, high-speed internet connectivity, and licensed
          software to support practical learning in Computer Science,
          Information Technology, Artificial Intelligence, Data Science, and
          allied disciplines.
        </p>
      </section>

      {/* Labs Gallery */}
      <section className="ictlabs-gallery-section">
        <div className="ictlabs-gallery">
          {ictLabsData.map((lab, index) => (
            <div className="lab-card" key={index}>
              <img src={lab.image} alt={lab.title} />
              <div className="lab-overlay">
                <h3>{lab.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
    <Footer />
    </>
  );
};

export default ICTLabs;
